import React from 'react';
export function PowerTools() {
  return <section className="py-24 px-4 relative" data-id="element-81">
      <div className="max-w-6xl mx-auto" data-id="element-82">
        <div className="mb-16 md:w-2/3" data-id="element-83">
          <span className="text-amber-500 text-sm tracking-widest uppercase mb-4 block" data-id="element-84">
            Arsenal Táctico
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-zinc-100 mb-6" data-id="element-85">
            Herramientas de Poder
          </h2>
          <p className="text-xl text-zinc-400" data-id="element-86">
            Prácticas diseñadas no para consolarte, sino para liberarte.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-87">
          {/* Tool 1 */}
          <div className="group relative overflow-hidden bg-zinc-900 p-8 border border-zinc-800 hover:border-amber-500/50 transition-all duration-500" data-id="element-88">
            <div className="absolute top-0 right-0 w-24 h-24 bg-amber-500/5 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-150" data-id="element-89"></div>
            <div className="text-amber-500 font-serif text-4xl mb-6 opacity-50" data-id="element-90">
              01
            </div>
            <h3 className="text-xl text-zinc-100 font-serif mb-4" data-id="element-91">
              Técnica del Espejo Vacío
            </h3>
            <p className="text-zinc-400" data-id="element-92">
              Aprende a validar tu propio dolor sin requerir una gota de permiso
              externo. Tú eres el único testigo que importa.
            </p>
          </div>

          {/* Tool 2 */}
          <div className="group relative overflow-hidden bg-zinc-900 p-8 border border-zinc-800 hover:border-amber-500/50 transition-all duration-500" data-id="element-93">
            <div className="absolute top-0 right-0 w-24 h-24 bg-amber-500/5 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-150" data-id="element-94"></div>
            <div className="text-amber-500 font-serif text-4xl mb-6 opacity-50" data-id="element-95">
              02
            </div>
            <h3 className="text-xl text-zinc-100 font-serif mb-4" data-id="element-96">
              La Cámara de Seguridad
            </h3>
            <p className="text-zinc-400" data-id="element-97">
              Un ejercicio mental para observar los hechos pasados con frialdad
              clínica, despojándolos del peso del drama y la narrativa de
              víctima.
            </p>
          </div>

          {/* Tool 3 */}
          <div className="group relative overflow-hidden bg-zinc-900 p-8 border border-zinc-800 hover:border-amber-500/50 transition-all duration-500" data-id="element-98">
            <div className="absolute top-0 right-0 w-24 h-24 bg-amber-500/5 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-150" data-id="element-99"></div>
            <div className="text-amber-500 font-serif text-4xl mb-6 opacity-50" data-id="element-100">
              03
            </div>
            <h3 className="text-xl text-zinc-100 font-serif mb-4" data-id="element-101">
              Higiene de Paz
            </h3>
            <p className="text-zinc-400" data-id="element-102">
              Protocolos estrictos para proteger tu nueva frecuencia vibratoria
              de los chismes, las recaídas nostálgicas y los fantasmas del
              pasado.
            </p>
          </div>
        </div>
      </div>
    </section>;
}